import { render, staticRenderFns } from "./DeleteLut.vue?vue&type=template&id=c80d0df6&"
import script from "./DeleteLut.vue?vue&type=script&lang=js&"
export * from "./DeleteLut.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports